import { Phone, Mail, MessageCircle, Facebook, Instagram, MapPin } from "lucide-react";

const ContactBanner = ({ category }) => {
    if (!category) return null;

    const handleWhatsAppClick = () => {
        if (category.whatsapp) {
            const cleanNumber = category.whatsapp.replace(/\s+/g, '');
            window.open(`https://wa.me/${cleanNumber}`, '_blank');
        }
    };

    const handleSocialClick = (url) => {
        if (url) {
            window.open(url, '_blank');
        }
    };

    const handleCallClick = (number) => {
        if (number) {
            window.location.href = `tel:${number}`;
        }
    };

    const handleEmailClick = () => {
        if (category.email) {
            window.location.href = `mailto:${category.email}`;
        }
    };

    return (
        <div className="bg-primary rounded-xl shadow-xl p-8 mt-12 mb-8">
            <div className="max-w-6xl mx-auto">
                {/* Header */}
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-white mb-2">Get In Touch</h2>
                    <p className="text-white text-lg">{category.contact_details}</p>
                </div>

                {/* Contact Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {/* Landline */}
                    {category.landline && (
                        <div
                            onClick={() => handleCallClick(category.landline)}
                            className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition cursor-pointer"
                        >
                            <div className="flex flex-col items-center text-center">
                                <div className="bg-[#F29E38] rounded-full p-3 mb-3">
                                    <Phone className="w-6 h-6 text-white" />
                                </div>
                                <h3 className="text-white font-semibold mb-1">Landline</h3>
                                <p className="text-white text-sm">{category.landline}</p>
                            </div>
                        </div>
                    )}

                    {/* Cell Number */}
                    {category.cell_nr && (
                        <div
                            onClick={() => handleCallClick(category.cell_nr)}
                            className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition cursor-pointer"
                        >
                            <div className="flex flex-col items-center text-center">
                                <div className="bg-[#F29E38] rounded-full p-3 mb-3">
                                    <Phone className="w-6 h-6 text-white" />
                                </div>
                                <h3 className="text-white font-semibold mb-1">Cell Number</h3>
                                <p className="text-white text-sm">{category.cell_nr}</p>
                            </div>
                        </div>
                    )}

                    {/* WhatsApp */}
                    {category.whatsapp && (
                        <div
                            onClick={handleWhatsAppClick}
                            className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition cursor-pointer"
                        >
                            <div className="flex flex-col items-center text-center">
                                <div className="bg-[#25D366] rounded-full p-3 mb-3">
                                    <MessageCircle className="w-6 h-6 text-white" />
                                </div>
                                <h3 className="text-white font-semibold mb-1">WhatsApp</h3>
                                <p className="text-white text-sm">{category.whatsapp}</p>
                            </div>
                        </div>
                    )}

                    {/* Email */}
                    {category.email && (
                        <div
                            onClick={handleEmailClick}
                            className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition cursor-pointer"
                        >
                            <div className="flex flex-col items-center text-center">
                                <div className="bg-[#F29E38] rounded-full p-3 mb-3">
                                    <Mail className="w-6 h-6 text-white" />
                                </div>
                                <h3 className="text-white font-semibold mb-1">Email</h3>
                                <p className="text-white text-sm break-all">{category.email}</p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Social Media & Google */}
                <div className="flex flex-wrap items-center justify-center gap-4 mt-8 pt-8 border-t border-white/20">
                    <p className="text-white font-semibold">Connect with us:</p>

                    {category.facebook && (
                        <button
                            onClick={() => handleSocialClick(category.facebook)}
                            className="bg-[#1877F2] hover:bg-[#166FE5] text-white px-4 py-2 rounded-lg flex items-center gap-2 transition"
                        >
                            <Facebook className="w-5 h-5" />
                            <span>Facebook</span>
                        </button>
                    )}

                    {category.instagram && (
                        <button
                            onClick={() => handleSocialClick(`https://instagram.com/${category.instagram.replace('@', '')}`)}
                            className="bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] hover:opacity-90 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition"
                        >
                            <Instagram className="w-5 h-5" />
                            <span>{category.instagram}</span>
                        </button>
                    )}

                    {category.google_listing && (
                        <button
                            onClick={() => handleSocialClick(category.google_listing)}
                            className="bg-white hover:bg-gray-100 text-primary px-4 py-2 rounded-lg flex items-center gap-2 transition"
                        >
                            <MapPin className="w-5 h-5" />
                            <span>Google Maps</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactBanner;
